var _a, _b;
import { IdSoundState } from "../../constants/IdSoundState";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { IdIcon } from "../generic/icon/IdIcon";
export var mapSettingsButtonSoundDisplay = new Map([
    [
        IdSoundGroup.Sound,
        {
            icon: IdIcon.SoundIcn,
            locas: (_a = {},
                _a[IdSoundState.Disabled] = IdLoca.settingsMenu_soundOff,
                _a[IdSoundState.Enabled] = IdLoca.settingsMenu_soundOn,
                _a),
        },
    ],
    [
        IdSoundGroup.Music,
        {
            icon: IdIcon.MusicIcn,
            locas: (_b = {},
                _b[IdSoundState.Disabled] = IdLoca.settingsMenu_musicOff,
                _b[IdSoundState.Enabled] = IdLoca.settingsMenu_musicOn,
                _b),
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/mapSettingsButtonSoundDisplay.ts
// module id = 2753
// module chunks = 3